export default __webpack_public_path__ + "static/media/logo3.b5e6260a.jpg";